// Heatmap API client.
//
// Single helper: `fetchHeatmapBuckets(endpoint, params)`. Endpoint is
// the layer-relative path (e.g. "/heatmap/buy"); params drive the
// server-side filter:
//
//   bucket_type:   "postal_code" | "district" | "geo_grid_500m"
//   bbox:          "<sw_lat>,<sw_lng>,<ne_lat>,<ne_lng>"
//   min_samples:   int
//   limit:         int  (default 1000, max 5000)
//
// The axios baseURL already includes `/api`, so we pass the endpoint
// relatively without the prefix.
import { apiClient } from "./client";

export async function fetchHeatmapBuckets(endpoint, params = {}, { signal } = {}) {
  const cleaned = {};
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue;
    cleaned[k] = v;
  }
  // 25s bound: a hanging request must never freeze the map UI.
  const r = await apiClient.get(endpoint, { params: cleaned, signal, timeout: 25000 });
  return r.data;
}

// Welle 4.2 — clickable deal markers inside the viewport bbox.
// Welle 4.3 — supports AbortController cancellation so stale viewport
// responses never overwrite newer ones.
export async function fetchHeatmapDeals(params = {}, { signal } = {}) {
  const r = await apiClient.get("/heatmap/deals", { params, signal });
  return r.data;
}

// Welle 5 — Investment Explorer: ONE endpoint powers map markers,
// viewport count and the list view with identical filter semantics.
export async function fetchExploreSearch(params = {}, { signal } = {}) {
  const r = await apiClient.get("/explore/search", { params, signal, timeout: 25000 });
  return r.data;
}

// Helper: build the bbox string from a Leaflet bounds object.
export function bboxFromLeafletBounds(bounds) {
  if (!bounds) return null;
  const sw = bounds.getSouthWest();
  const ne = bounds.getNorthEast();
  return [sw.lat, sw.lng, ne.lat, ne.lng].join(",");
}
